import Relation from "../../../model2/relation/relation"

// The PROJECT branch of goToItem: a link from an action-items board carries the
// todo-view id, so it opens that board; a plain link opens the default view.
export default function goToProjectItem(relation: Relation) {
    const viewId = relation.projectViewId

    if (viewId) return gd.navigation.goToProject(relation.relatedItem.id, "/todos/" + viewId)
    return gd.navigation.goToProject(relation.relatedItem.id)
}
